import { Component } from '@angular/core';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { LayoutService } from './core/components/app-layout/services/layout.service';
import { StorageService } from './core/services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'CSS App';
  constructor(private adalService: MsAdalAngular6Service,
    public session: StorageService,private layoutService: LayoutService) {
  }

  loginSuccess=1;

  ngOnInit(): void {
    let user = this.getLoggedInUser();
    if (!!user) {
      //console.log(user);
      this.session.userId = user
      this.session.userEmail = user
      if(!this.session.language)
        this.session.language = 'en'
      this.layoutService.getLoginInfo(this.session.userId).subscribe((resUser) => {
        if(resUser.error && (resUser.error=="Unauthorized" || resUser.errorCode==400))
        {
          this.session.loggednUser = null;
          this.loginSuccess=3;
          this.session.userId=null;
        }
        else
        {
          this.loginSuccess=2;
          this.session.loggednUser = resUser;
          if (!this.session.resource)
            this.setResource();
        }
      },
      error=>{
        this.loginSuccess=3;
        this.session.loggednUser = null;
        this.session.userId=null;
      });
    }
    else {
      this.login();

    }
  }

  setResource() {
    this.layoutService.getResource(this.session.language).subscribe(
      res1 => {
        //console.log(res1);
        this.session.resource = res1;
      },
      (err) => {
        console.log(err.message);
      }
    );
  }

  login(): void {
    this.adalService.login();
  }
  getLoggedInUser(): any {
    //console.log(this.adalService.LoggedInUserName);
    return this.adalService.LoggedInUserEmail;
  }
}
